module.exports = __webpack_public_path__ + "img/avatar1.4449bd6c.png";